var map = {
	"./Art and Craft Club.webp": 508,
	"./Athletics.avif": 3733,
	"./Basketball.jpg": 2397,
	"./Cricket.jpg": 2271,
	"./Cultural Festivals.webp": 8897,
	"./Drama Club.jpg": 3387,
	"./Environment Club.avif": 5999,
	"./Football.jpg": 7927,
	"./Football.webp": 9279,
	"./Health Awareness Campaigns.png": 5636,
	"./Literary Club.png": 8570,
	"./Music Band.avif": 7118,
	"./Science Society.jpg": 7270,
	"./Sports Tournaments.avif": 6159,
	"./Yoga.webp": 7186,
	"./avatar.jpg": 5003,
	"./cbsc.jpeg": 1786,
	"./details-rsps.jpg": 977,
	"./details-rsps1.jpg": 7040,
	"./gi1.mp4": 7676,
	"./gi10.jpg": 5379,
	"./gi11.mp4": 6651,
	"./gi12.mp4": 6644,
	"./gi13.mp4": 6825,
	"./gi14.jpg": 8063,
	"./gi15.jpg": 5394,
	"./gi16.jpg": 4653,
	"./gi17.jpg": 3728,
	"./gi18.jpg": 5483,
	"./gi19.jpg": 9646,
	"./gi2.mp4": 9139,
	"./gi20.jpg": 3070,
	"./gi21.jpg": 4379,
	"./gi22.jpg": 7404,
	"./gi23.jpg": 2665,
	"./gi24.jpg": 6202,
	"./gi25.jpg": 3719,
	"./gi26.jpg": 6440,
	"./gi27.jpg": 405,
	"./gi28.jpg": 294,
	"./gi29.jpg": 5555,
	"./gi3.mp4": 654,
	"./gi30.jpg": 709,
	"./gi31.jpg": 2840,
	"./gi32.jpg": 6647,
	"./gi33.jpg": 4458,
	"./gi34.jpg": 5353,
	"./gi35.jpg": 4300,
	"./gi36.jpg": 2635,
	"./gi37.jpg": 4590,
	"./gi38.jpg": 3245,
	"./gi39.jpg": 1024,
	"./gi4.mp4": 5885,
	"./gi40.jpg": 6200,
	"./gi41.jpg": 3461,
	"./gi42.jpg": 6122,
	"./gi43.jpg": 5127,
	"./gi44.jpg": 1340,
	"./gi45.jpg": 8713,
	"./gi5.mp4": 4520,
	"./gi6.jpg": 520,
	"./gi7.jpg": 2885,
	"./gi8.jpg": 1846,
	"./gi9.jpg": 5011,
	"./intro-1-rsps.jpg": 3763,
	"./intro-2-rsps.jpg": 2798,
	"./intro-rsps.jpg": 7733,
	"./new_vac.jpg": 7947,
	"./pv1.mp4": 4174,
	"./pv2.mp4": 3009,
	"./pv3.mp4": 8140,
	"./rising-star-bg.jpg": 4477,
	"./rising-star-logo-1.jpg": 4515,
	"./rising-star-logo.jpg": 4569,
	"./rsps-logo2.png": 428,
	"./sci-math.webp": 1844,
	"./upclass8.jpeg": 2104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4591;